// import {load} from '@shopify/theme-sections';
import AccordionList from '../components/accordion-list';
import 'nodelist-foreach-polyfill';

const components = {
  AccordionList,
};

// Instantiate components automatically
document.querySelectorAll('[data-component]').forEach((el) => {
  if (components[el.dataset.component]) {
    new components[el.dataset.component](el);
  } else {
    console.error(el.dataset.component, 'component is not defined.');
  }

  var iframes = document.querySelectorAll(
    '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'
  );

  iframes.forEach(function(el) {
    const div = document.createElement('div');
    el.parentElement.insertBefore(div, el);
    div.appendChild(el);
    div.classList.add('rte__video-wrapper');
  });

  var tables = document.querySelectorAll('.rte table');

  tables.forEach(function(el) {
    const div = document.createElement('div');
    el.parentElement.insertBefore(div, el);
    div.appendChild(el);
    div.classList.add('rte__table-wrapper');
  });
});
